/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

async function loadAllProducts() {
  const templateSuffix = "json-bb";
  const collectionHandle = "all";
  let urlPrefix = window.theme.routes.root;

  if (urlPrefix !== "/") urlPrefix += "/";

  const response = await fetch(
    `${urlPrefix}collections/${collectionHandle}?view=${templateSuffix}`,
    {
      type: "GET",
    }
  );

  const json = await response.json();
  window.ALL_PRODUCTS = json.products;
}

(function() {
  // Add custom code below this line
  loadAllProducts().then(() => {
    // console.log(window.ALL_PRODUCTS);
  });

  // If the /cart page, run some JS
  if (location.pathname.includes('/cart')) {
    setTimeout(() => { 
      const giftWrapLineItem = document.querySelector('.cart-item[data-item-sku="giwr1"]');
      if (giftWrapLineItem) {

        const wrapinBlock = document.querySelector('#ptw-wrapin');
        if (wrapinBlock) {
          wrapinBlock.remove();
        }

        const cartWidgetGift = document.querySelector('.cart__widget-gift');
        if (cartWidgetGift) {
          cartWidgetGift.classList.remove('hidden');

          cartWidgetGift.querySelector('a[data-expand-button')?.click();
        }
      }

      const addGiftButton = document.querySelector('#ptw-add-gift-pro');

      if (addGiftButton) {        
        addGiftButton.addEventListener('click', (e) => {
          e.preventDefault();
          location.reload();
        });
      }
    }, 200);
  }
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
